"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AppBase = _interopRequireDefault(require("../App/AppBase"));

var _AppHeader = _interopRequireDefault(require("../App/AppHeader"));

var _AppNav = _interopRequireDefault(require("../App/AppNav"));

var _AppBody = _interopRequireDefault(require("../App/AppBody"));

var _AppContent = _interopRequireDefault(require("../App/AppContent"));

var _AppSidebar = _interopRequireDefault(require("../App/AppSidebar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const layouts = {
  "default": {
    nav: {
      expanded: true
    },
    header: {
      expanded: false
    },
    sidebar: {
      expanded: false
    }
  },
  "dashboard": {
    nav: {
      expanded: true
    },
    header: {
      expanded: true
    },
    sidebar: {
      expanded: false
    },
    search: {
      disabled: true
    }
  },
  "finder": {
    nav: {
      expanded: true
    },
    header: {
      expanded: true
    },
    sidebar: {
      expanded: true
    },
    subview: {
      expanded: false
    }
  },
  "finder/search": {
    nav: {
      expanded: false
    },
    header: {
      expanded: true
    },
    sidebar: {
      expanded: true
    },
    search: {
      expanded: true
    },
    subview: {
      expanded: false
    }
  },
  "finder/upload": {
    nav: {
      expanded: true
    },
    header: {
      expanded: true
    },
    sidebar: {
      expanded: false
    },
    subview: {
      expanded: true
    }
  },
  "finder/subview": {
    nav: {
      expanded: true
    },
    header: {
      expanded: true
    },
    sidebar: {
      expanded: false
    },
    subview: {
      expanded: true
    }
  },
  "editor": {
    nav: {
      expanded: false
    },
    header: {
      expanded: false
    },
    sidebar: {
      expanded: false
    }
  }
};

class LayoutAdmin extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      theme: undefined,
      nav: {
        expanded: true
      },
      header: {
        expanded: false
      },
      sidebar: {
        expanded: false
      },
      search: {
        expanded: false
      },
      subview: {
        expanded: false
      }
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.app !== this.props.app) {
        this.getApp();
      } else {
        if (prevProps.theme !== this.props.theme) {
          this.getTheme();
        }

        if (prevProps.layout !== this.props.layout) {
          this.getLayout();
        }

        if (prevProps.search !== this.props.search) {
          this.getSearch();
        }

        if (prevProps.subview !== this.props.subview) {
          this.getSubview();
        }
      }
    });

    _defineProperty(this, "getApp", () => {
      const theme = this.props.theme || this.props.app.theme || undefined;
      const layout = this.props.layout || this.props.app.layout || undefined;
      const search = this.props.search || this.props.app.search || undefined;
      const subview = this.props.subview || this.props.app.subview || undefined;
      let layoutState;

      if (layouts[layout]) {
        layoutState = layouts[layout];
      } else if (typeof layout === 'object' && layout !== null) {
        layoutState = layout;
      } else {
        layoutState = layouts['default'];
      }

      this.setState(_extends({}, this.state, {}, layoutState, {
        theme: theme,
        search: search,
        subview: subview
      }));
    });

    _defineProperty(this, "getTheme", () => {
      const theme = this.props.theme || this.props.app.theme || undefined;
      this.setState({
        theme: theme
      });
    });

    _defineProperty(this, "getLayout", () => {
      const layout = this.props.layout || this.props.app.layout || undefined;
      let layoutState;

      if (layouts[layout]) {
        layoutState = layouts[layout];
      } else if (typeof layout === 'object' && layout !== null) {
        layoutState = layout;
      } else {
        layoutState = layouts['default'];
      }

      this.setState(_extends({}, this.state, {}, layoutState));
    });

    _defineProperty(this, "getSearch", () => {
      const search = this.props.search;

      if (search) {
        this.setState({
          search: search
        });
      }
    });

    _defineProperty(this, "getSubview", () => {
      const subview = this.props.subview;

      if (subview) {
        this.setState({
          subview: subview
        });
      }
    });

    _defineProperty(this, "renderSidebar", () => {
      const sidebar = this.state.sidebar;
      const onSelect = this.props.onSelect;
      const button = this.props.button || this.props.app.button || undefined;
      const edit = this.props.edit || this.props.app.edit || button && [button] || [];
      const menu = this.props.menu || this.props.app.menu || undefined;
      const menuByUrl = this.props.menuByUrl || this.props.app.menuByUrl || undefined;
      const currentUrl = this.props.currentUrl || this.props.url || undefined;
      return _react.default.createElement(_AppSidebar.default, {
        expanded: sidebar.expanded || false,
        onSelect: onSelect,
        edit: edit,
        menu: menu,
        menuByUrl: menuByUrl,
        onSelect: onSelect,
        currentUrl: currentUrl
      });
    });
  }

  // update state
  componentDidMount() {
    this.getApp();
  }

  render() {
    const _this$props = this.props,
          app = _this$props.app,
          user = _this$props.user,
          owner = _this$props.owner,
          onSelect = _this$props.onSelect,
          onToggle = _this$props.onToggle,
          onLogin = _this$props.onLogin,
          onLogout = _this$props.onLogout;
    const _this$state = this.state,
          nav = _this$state.nav,
          theme = _this$state.theme,
          header = _this$state.header,
          search = _this$state.search,
          subview = _this$state.subview;
    const title = app && app.title;
    const subtitle = owner && owner.uniqueId && owner.title || user && user.uniqueId && user.name;
    return _react.default.createElement(_AppBase.default, {
      theme: theme || undefined
    }, _react.default.createElement(_AppNav.default, {
      expanded: nav && nav.expanded,
      app: app,
      user: user,
      owner: owner,
      onLogin: onLogin,
      onLogout: onLogout,
      onSelect: onSelect
    }), _react.default.createElement(_AppHeader.default, {
      expanded: header && header.expanded,
      title: title,
      subtitle: subtitle,
      subview: subview,
      search: search || false,
      onToggle: onToggle
    }), _react.default.createElement(_AppBody.default, {
      expanded: header && !header.expanded
    }, this.renderSidebar(), _react.default.createElement(_AppContent.default, null, this.props.children)));
  }

}

_defineProperty(LayoutAdmin, "defaultProps", {
  app: {
    title: "App",
    subtitle: "Owner or user",
    theme: undefined,
    layout: undefined,
    version: 0.1
  },
  theme: undefined,
  layout: undefined,
  user: {
    uniqueId: undefined
  },
  owner: {
    uniqueId: undefined
  }
});

var _default = LayoutAdmin;
exports.default = _default;
module.exports = exports.default;